/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EvaluateEligibilityCommandDto
 */
export interface EvaluateEligibilityCommandDto {
    /**
     * 
     * @type {string}
     * @memberof EvaluateEligibilityCommandDto
     */
    branchCode: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EvaluateEligibilityCommandDto
     */
    realEstateIds: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof EvaluateEligibilityCommandDto
     */
    effectiveDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof EvaluateEligibilityCommandDto
     */
    terminationClauseGlobal?: boolean | null;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof EvaluateEligibilityCommandDto
     */
    terminationClauseOverrides?: { [key: string]: boolean; } | null;
}

/**
 * Check if a given object implements the EvaluateEligibilityCommandDto interface.
 */
export function instanceOfEvaluateEligibilityCommandDto(value: object): value is EvaluateEligibilityCommandDto {
    if (!('branchCode' in value) || value['branchCode'] === undefined) return false;
    if (!('realEstateIds' in value) || value['realEstateIds'] === undefined) return false;
    return true;
}

export function EvaluateEligibilityCommandDtoFromJSON(json: any): EvaluateEligibilityCommandDto {
    return EvaluateEligibilityCommandDtoFromJSONTyped(json, false);
}

export function EvaluateEligibilityCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluateEligibilityCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'branchCode': json['branchCode'],
        'realEstateIds': json['realEstateIds'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
        'terminationClauseGlobal': json['terminationClauseGlobal'] == null ? undefined : json['terminationClauseGlobal'],
        'terminationClauseOverrides': json['terminationClauseOverrides'] == null ? undefined : json['terminationClauseOverrides'],
    };
}

export function EvaluateEligibilityCommandDtoToJSON(json: any): EvaluateEligibilityCommandDto {
    return EvaluateEligibilityCommandDtoToJSONTyped(json, false);
}

export function EvaluateEligibilityCommandDtoToJSONTyped(value?: EvaluateEligibilityCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'branchCode': value['branchCode'],
        'realEstateIds': value['realEstateIds'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate'] as any).toISOString()),
        'terminationClauseGlobal': value['terminationClauseGlobal'],
        'terminationClauseOverrides': value['terminationClauseOverrides'],
    };
}

